export default __webpack_public_path__ + "static/media/Goldspar Högblank Fernissa.7aeee272.jpg";